export class PathAction {

    static fromCreateWaitingConsult = 'fromCreateWaitingConsult';
    static fromCreateWaitingConsultSaved = 'fromCreateWaitingConsultSaved';

    static fromEditBookingDialog = 'fromEditBookingDialog';
    static fromEditBookingDialogSaved = 'fromEditBookingDialogSaved';

    static fromPatientHistory = 'fromPatientHistory';
    static fromPatientHistorySaved = 'fromPatientHistorySaved';


    static fromOutstandingBill = 'fromOutstandingBill';

    static fromSavePatient = 'fromSavePatient';

    static fromVoidVoucher = 'fromVoidVoucher';
    static fromVoidVoucherBackday = 'fromVoidVoucherBackday';
    static fromHistoryBackday = 'fromHistoryBackday';
    static fromPatientMaster = 'fromPatientMaster';
    static fromXray='fromXray';
    static fromPhysio='fromPhysio';
}